// import styles

import '../scss/main.scss'
import 'bootstrap/js/src/collapse'

import $ from 'jquery';
import slick from 'slick-carousel';

$(document).ready(function () {
    productGallerySlider();
    relatedArticleSlider();
    ourPartnersSlider();
    recommendedProductsSlider();
    choseTags();
})


function productGallerySlider() {
    let productGallerySlider = $('#productGallerySlider')
    if (productGallerySlider.length > 0) {
        productGallerySlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            infinite: true,
            prevArrow: $('#productGallerySliderPrev'),
            nextArrow: $('#productGallerySliderNext')
        })
    }
}

function relatedArticleSlider() {
    let relatedArticleGallery = $('#relatedArticleGallery')
    if (relatedArticleGallery.length > 0) {
        relatedArticleGallery.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            centerMode: false,
            focusOnSelect: false,
            infinite: true,
            arrows: true,
            prevArrow: $('#relatedArticleGalleryPrev'),
            nextArrow: $('#relatedArticleGalleryNext'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: false,
                        vertical: false,
                    }
                }
            ]
        })
    }
}

function ourPartnersSlider() {
    let ourPartnersSlider = $('.js-ourPartnersSlider')
    if (ourPartnersSlider.length > 0) {
        ourPartnersSlider.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            rows: 2,
            dots: false,
            centerMode: false,
            focusOnSelect: false,
            infinite: true,
            arrows: true,
            prevArrow: $('.js-ourPartnersSliderPrev'),
            nextArrow: $('.js-ourPartnersSliderNext'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: false,
                        vertical: false,
                    }
                }
            ]
        })
    }
}

function recommendedProductsSlider() {
    let recommendedProductsSlider = $('#recommendedProductsSlider')
    if (recommendedProductsSlider.length > 0) {
        recommendedProductsSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            centerMode: false,
            focusOnSelect: false,
            infinite: true,
            arrows: true,
            prevArrow: $('#recommendedProductsSliderPrev'),
            nextArrow: $('#recommendedProductsSliderNext'),
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: true,
                        infinite: true,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        infinite: true,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        infinite: true,
                        vertical: false,
                    }
                }
            ]
        })
    }
}


function choseTags() {
    const choosenTagsTemplate = function (name, slug) {
        return `
            <p class="tire-type__tags" id="${slug}">
               <span class="tag d-flex align-items-center">${name}
               <input type="text" name="catalogTags[]" id="catalog-tags" value="${slug}" hidden>
                 <a href="#" class="close-tag">
                    <svg id="usuń_filtr" data-name="usuń filtr" xmlns="http://www.w3.org/2000/svg"
                                             width="15" height="15" viewBox="0 0 15 15">
  <circle id="Ellipse_39" data-name="Ellipse 39" cx="7.5" cy="7.5" r="7.5" fill="#e3e3e3"/>
  <g id="Group_401" data-name="Group 401" transform="matrix(0.695, 0.719, -0.719, 0.695, -159.371, -946.451)">
    <line id="Line_14" data-name="Line 14" y2="8.266" transform="translate(802.133 538.5)" fill="none" stroke="#fff"
          stroke-width="2"/>
    <line id="Line_15" data-name="Line 15" x1="8.266" transform="translate(798 542.633)" fill="none" stroke="#fff"
          stroke-width="2"/>
  </g>
</svg>
                  </a>
                </span>
            </p>`;
    }

    const tagsContainer = $('#tagsContainer');
    const tagsList = $('#tagsList');

    tagsContainer.on('click', '.tag', function (e) {
        e.preventDefault()
        let name = $(this).attr('data-name'), slug = $(this).attr('data-slug')
        if (tagsList.find('#' + slug).length > 0) {
            tagsList.find('#' + slug).remove()
        } else {
            tagsList.append(choosenTagsTemplate(name, slug))
        }
    })
    tagsList.on('click', '.close-tag', function (e) {
        e.preventDefault()
        $(this).parents('.tire-type__tags').remove()
    })

}